import React, { useEffect, useState } from "react";
import Popup from "../../../components/common/model/Popup";
import checkedIcon from "../../../assets/check-mark.png";
import closeIcon from "../../../assets/closeModel.png";
import useStyles from "../../../components/common/model/styles";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import CustomerDetailsForm from "./CustomerDetailsForm";
import CollectionForm from "./CollectionForm";
import DeliveryForm from "./DeliveryForm";
import CustomerNotesForm from "./CustomerNotesForm";
import CustomButton from "../../../components/common/button/CustomButton";
import Validation from "../../../utils/Validation";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  addNewLeadAction,
  getAllReferrerListAction,
  initialLeadLocalState,
  resetNewLeadLocal,
  setAddNewLeadAction,
  setNewLeadLocal,
  setUpdateLeadAction,
  updateLeadAction,
} from "../../../store/reducers/leadSlice";
import Notification from "../../../components/common/notification/Notification";
import AlertCloseLead from "./AlertCloseLead";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import { setAddReferrerResponse } from "../../../store/reducers/referrerSlice";
import DistanceMapModal from "./CustomerLead/DistanceMapModal";
import { mergeDateAndTime } from "../../../hooks/helper";

interface ManageLeadProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectLead: any; // Adjust type as per your requirement
  action?: any;
  setSelectedLead?: any;
}

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  key: string;
}

const ManageLead: React.FC<ManageLeadProps> = (props) => {
  const classes = useStyles();
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("lg"); // Adjust the type definition

  const { onHide, open, selectLead, title } = props;
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [openMap, setOpenMap] = useState(false);
  const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
    key: "",
  });

  const dispatch = useDispatch();
  const { newLeadLocal, referrers, isAddLeadSuccess, isUpdateLeadSuccess } =
    useSelector((state: any) => state.lead);

  const { isAddReferrerSuccess } = useSelector((state: any) => state.referrer);
  // useEffect(() => {
  //   dispatch(getUserProfile());
  // }, []);
  const { userProfile } = useSelector((state: any) => state.user);
  const [isProfessionalSection, setIsProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Lead") || false, // Safe fallback
  );
  const [formData, setFormData]: any = React.useState(initialLeadLocalState);
  const [countryCode, setCountryCode] = useState<string>("+44"); // State for country code
  const [alternateCountryCode, setAlternateCountryCode] =
    useState<string>("+44");
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [oldLeadLocalState, setOldLeadLocalState] = useState(
    initialLeadLocalState,
  );

  useEffect(() => {
    if (selectLead) {
      setCountryCode(
        selectLead?.customer_country_code
          ? selectLead?.customer_country_code
          : "+44",
      );
      setAlternateCountryCode(
        selectLead?.alternate_country_code ||
        selectLead?.customer_alternate_country_code
          ? (selectLead?.alternate_country_code ||
            selectLead?.customer_alternate_country_code)
          : "+44",
      );

      // Safely convert address fields from string to number
      const collectionAddress = (
        selectLead?.collection_address?.length > 0
          ? selectLead?.collection_address
          : [
              {
                building_number: "",
                street: "",
                town: "",
                county: "",
                postcode: "",
                country: "",
                purchaseStatus: "",
                houseSize: "",
                distance: 0,
                volume: 0,
                volumeUnit: "m3",
              },
            ]
      ).map((addr: any) => ({
        ...addr,
        county: addr?.county,
        country: addr?.country,
        distance: addr?.distance ? Number(addr.distance) : 0,
        volume: addr?.volume ? Number(addr.volume) : 0,
        volumeUnit: addr?.volume_unit || "m3",
        houseSize: addr?.house_size,
        purchaseStatus: addr?.purchase_status,
      }));

      const deliveryAddress = (
        selectLead?.delivery_address?.length > 0
          ? selectLead?.delivery_address
          : [
              {
                building_number: "",
                street: "",
                town: "",
                county: "",
                postcode: "",
                country: "",
                purchaseStatus: "",
                houseSize: "",
                distance: 0,
                volume: 0,
                volumeUnit: "m3",
              },
            ]
      ).map((addr: any) => ({
        ...addr,
        county: addr?.county,
        country: addr?.country,
        distance: addr?.distance ? Number(addr.distance) : 0,
        volume: addr?.volume ? Number(addr.volume) : 0,
        volumeUnit: addr?.volume_unit || "m3",
        houseSize: addr?.house_size,
        purchaseStatus: addr?.purchase_status,
      }));

      const updatedLead = {
        ...newLeadLocal,
        referrerId: selectLead?.referrer_id ?? selectLead?.client_referrer_id,
        customer: {
          name: selectLead?.customer_name,
          country_code: selectLead?.customer_country_code
            ? selectLead?.customer_country_code
            : "+44",
          phone: selectLead?.customer_phone
            ? selectLead?.customer_phone.replace(/^(\+91|\+44)/, "")
            : "",
          email: selectLead?.customer_email,
          alternate_phone: (selectLead?.alternate_phone ||
            selectLead?.customer_alternate_phone)
            ? (selectLead?.alternate_phone ||
                selectLead?.customer_alternate_phone
              ).replace(/^(\+91|\+44)/, "")
            : "",
          alternate_country_code:
            selectLead?.alternate_country_code ||
            selectLead?.customer_alternate_country_code ||
            "+44",
          account_name: selectLead?.customer_account_name,
          prefix: selectLead?.customer_prefix,
        },
        collectionAddress,
        deliveryAddress,
        followUpDate: selectLead?.follow_up_date,
        followUpEndDate:
          selectLead?.follow_up_date && selectLead?.follow_up_end_date
            ? {
                start: selectLead.follow_up_date,
                end: selectLead.follow_up_end_date,
              }
            : "",
        movingOnDate: selectLead?.moving_on_end_date
          ? [selectLead?.moving_on_date, selectLead?.moving_on_end_date].filter(
              Boolean,
            )
          : selectLead?.moving_on_date,
        movingDate: selectLead?.moving_on_date,
        movingOnEndDate: selectLead?.moving_on_end_date,
        packingOnDate: selectLead?.packing_on_date,
        moveType: selectLead?.type_of_move,
        returningDistance: Number(selectLead?.returning_distance),
        customerNotes: selectLead?.customer_notes,
        advert_id: selectLead?.advert_id,
        promo_code: selectLead?.promo_code,
        promo_source: selectLead?.promo_source,
        sales_person_id: selectLead?.sales_person_id,
        sales_person_name: selectLead?.sales_person_name,
        lead_type_id: selectLead?.lead_type_id,
      };
      dispatch(setNewLeadLocal(updatedLead));
      setOldLeadLocalState(updatedLead);
    }
  }, [selectLead]);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    name: newLeadLocal?.customer?.name || "",
    referrerId: newLeadLocal?.referrerId || "",
    email: newLeadLocal?.customer?.email || "",
    phone: newLeadLocal?.customer?.phone || "",
  });

  const hideHandler = () => {
    if (hasUnsavedChanges) {
      setAlertModelShow(true);
    } else {
      props.onHide();
      dispatch(resetNewLeadLocal());
      dispatch(setNewLeadLocal(false));
      dispatch(setNotificationAction({ message: [], severity: "error" }));
      resetAllValidator();
      setFormData(initialLeadLocalState);
    }
  };

  useEffect(() => {
     dispatch(setNotificationAction({ message: [], severity: "error" }));
    dispatch(getAllReferrerListAction(filterOption));
  }, []);

  useEffect(() => {
    if (isAddReferrerSuccess) {
      dispatch(getAllReferrerListAction(filterOption));
      dispatch(setAddReferrerResponse(false));
    }
  }, [isAddReferrerSuccess]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      const { start, end } = newLeadLocal?.followUpEndDate || {};

      const followUpDate =
        mergeDateAndTime(newLeadLocal?.followUpDate, start) ||
        newLeadLocal?.followUpDate ||
        ""; // Use the original date if merging fails
      const followUpEndDate = mergeDateAndTime(newLeadLocal?.followUpDate, end);

      const processedLeadValue = {
        ...newLeadLocal,
        // Convert strings to numbers for each address object in collectionAddress
        collectionAddress: (newLeadLocal?.collectionAddress || []).map(
          (item: any) => ({
            ...item,
            distance: Number(item?.distance) || 0,
            volume: Number(item?.volume) || 0,
          }),
        ),

        // Convert strings to numbers for each address object in deliveryAddress
        deliveryAddress: (newLeadLocal?.deliveryAddress || []).map(
          (item: any) => ({
            ...item,
            distance: Number(item?.distance) || 0,
            volume: Number(item?.volume) || 0,
          }),
        ),
        customer: {
          ...newLeadLocal?.customer,
          phone: newLeadLocal?.customer?.phone
            ? `${newLeadLocal?.customer?.phone}`
            : "",
          country_code: countryCode,
          alternate_phone:
            newLeadLocal?.customer?.alternate_phone
              ? `${newLeadLocal?.customer?.alternate_phone}`
              : "",
          alternate_country_code: alternateCountryCode,
        },
        followUpDate,
        followUpEndDate,
        movingOnDate: Array.isArray(newLeadLocal?.movingOnDate)
          ? newLeadLocal?.movingOnDate[0]
          : newLeadLocal?.movingOnDate,
        movingOnEndDate: Array.isArray(newLeadLocal?.movingOnDate)
          ? newLeadLocal?.movingOnDate[1]
          : newLeadLocal?.movingOnEndDate,
        returningDistance: Number(newLeadLocal?.returningDistance) || 0,
      };

      if (!isError() && error !== null && isActionCalled) {
        // Apply referrer-related logic after validation
        if (newLeadLocal?.referrerId) {
          const matchedReferrer = referrers.find(
            (ref: any) => ref.id === newLeadLocal.referrerId,
          );

          if (matchedReferrer && matchedReferrer.from === "client") {
            processedLeadValue.clientReferrerId = newLeadLocal.referrerId;
            processedLeadValue.referrerId = null; // Make referrerId null
          }
        }
        if (selectLead?.generated_id) {
          dispatch(
            updateLeadAction({
              ...processedLeadValue,
              id: selectLead?.generated_id,
            }),
          );
        } else {
          dispatch(addNewLeadAction(processedLeadValue));
        }
        setHasUnsavedChanges(false);
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const closeModel = () => {
    hideHandler();
  };

  useEffect(() => {
    if (isAddLeadSuccess || isUpdateLeadSuccess) {
      hideHandler();
      dispatch(setUpdateLeadAction(false));
      dispatch(setAddNewLeadAction(false));
    }
  }, [isAddLeadSuccess, isUpdateLeadSuccess]);

  const [aleryModelShow, setAlertModelShow] = useState(false);

  const handleClose = () => {
    setAlertModelShow(false);
    props.onHide();
    dispatch(resetNewLeadLocal());
    dispatch(setNewLeadLocal(false));
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    resetAllValidator();

    setFormData(initialLeadLocalState);
  };

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        popupBg={"#fff"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              style={{ right: 40 }}
              alt="save"
            />

            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            {/* <CustomButton
              style={{ padding: "10px 30px", height: "36px" }}
              title="Save"
              onClick={handleSubmit}
            />
            <CustomButton
              style={{ padding: "10px 30px", height: "36px" }}
              variant="outlined"
              title="Cancel"
              onClick={closeModel}
            /> */}
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText>
            <>
              <Notification />
              <Grid container spacing={0}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{ display: "ruby", paddingLeft: "0px !important" }}
                >
                  <CustomerDetailsForm
                    resetValidator={resetValidator}
                    checkValidator={checkValidator}
                    error={error}
                    formData={formData}
                    setFormData={setFormData}
                    selectLead={selectLead}
                    setCountryCode={setCountryCode}
                    countryCode={countryCode}
                    setAlternateCountryCode={setAlternateCountryCode}
                    alternateCountryCode={alternateCountryCode}
                  />
                  <CollectionForm
                    resetValidator={resetValidator}
                    checkValidator={checkValidator}
                    error={error}
                    formData={formData}
                    setFormData={setFormData}
                  />
                  <DeliveryForm
                    resetValidator={resetValidator}
                    checkValidator={checkValidator}
                    error={error}
                    formData={formData}
                    setFormData={setFormData}
                  />
                  <CustomerNotesForm
                    resetValidator={resetValidator}
                    checkValidator={checkValidator}
                    error={error}
                    formData={formData}
                    setFormData={setFormData}
                  />
                  {isProfessionalSection && (
                    <CustomButton
                      title="Distance Map view"
                      onClick={() => setOpenMap(true)}
                      style={{ marginTop: 10 }}
                    />
                  )}
                </Grid>
              </Grid>
            </>
            <></>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {aleryModelShow && (
        <AlertCloseLead
          open={aleryModelShow}
          title={"Alert"}
          setAlertModelShow={setAlertModelShow}
          onHide={handleClose}
        />
      )}

      {openMap && (
        <DistanceMapModal
          open={openMap}
          onHide={() => setOpenMap(false)}
          collections={newLeadLocal?.collectionAddress || []}
          deliveries={newLeadLocal?.deliveryAddress || []}
        />
      )}
    </>
  );
};
export default ManageLead;
